<template>
  <div class="mmain">
    <mNewsList fenlei="机构动态"></mNewsList>
  </div>
</template>
<script>
import mNewsList from "@/components/mNewsList.vue";
import Bus from "@/utils/bus.js";
export default {
  data() {
    return {
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
  },
  components: {
    mNewsList
  }
};
</script>
<style lang="less" scoped>
.mmain {
  width: 100%;
}
</style>